export default __webpack_public_path__ + "static/media/tax-icon.af207ef0.svg";